module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/back-7d21d7b67083ab8d540cd2e8e63dfeb5.jpg";